import type { IconComponent } from './icon'

export const Folder: IconComponent = ({ className }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Folder</title>
            <path
                d="M5.5 19.8213L8 11.3213H20.25M5.5 19.8213H19.5L22 11.3213H20.25M5.5 19.8213H2.75V4.32129H10L12 7.32129H20.25V11.3213"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
